import { cva } from 'class-variance-authority';

export const toggleGroupVariants = cva(
  [
    'inline-flex',
    'flex-row',
    'flex-wrap',
    'items-center',
    'gap-spacing-comp-toggle-group-gap',
    'rounded-radius-comp-toggle-group',
  ],
  {
    variants: {
      variant: {
        default:
          'bg-color-ref-transparency-lighten-4 px-spacing-comp-toggle-group-horizontal py-spacing-comp-toggle-group-vertical',
        transparent: 'bg-color-ref-transparency-lighten-0',
      },
    },
    defaultVariants: {
      variant: 'default',
    },
  },
);
